"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ComponentTypes = require("./ComponentTypes");
var Window_1 = require("./Window");
var WindowManager_1 = require("./WindowManager");
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super.call(this) || this;
        _this._cellSize = 80;
        _this._cellMargin = 8;
        _this._rows = 30;
        _this._columns = 30;
        _this._setWindowViewports = function () {
            if (_this.portalManager) {
                var nx_1 = 0;
                var ny_1 = 0;
                var maxY_1 = 0;
                _this.windows.forEach(function (w) {
                    var data = _this._getGridData(w);
                    var x = data.colIndex;
                    var y = data.rowIndex;
                    var colSpan = data.colSpan;
                    var rowSpan = data.rowSpan;
                    if (!x) {
                        if (nx_1 + colSpan >= _this.columns) {
                            nx_1 = 0;
                            ny_1 = maxY_1;
                        }
                        x = nx_1;
                        nx_1 += colSpan;
                    }
                    if (!y) {
                        y = ny_1;
                    }
                    if (rowSpan > maxY_1) {
                        maxY_1 = rowSpan;
                    }
                    var vx = _this.x + _this.cellMargin + (x * (_this.cellSize + _this.cellMargin));
                    var vy = _this.y + _this.cellMargin + (y * (_this.cellSize + _this.cellMargin));
                    var width = colSpan * _this.cellSize + ((colSpan - 1) * _this.cellMargin);
                    var height = rowSpan * _this.cellSize + ((rowSpan - 1) * _this.cellMargin);
                    w.setViewport(vx, vy, width, height);
                });
            }
        };
        _this.windowSettings.borderWidth = 1;
        _this.windowSettings.headerHeight = 28;
        _this._setViewportDisposer = mobx_1.autorun(_this._setWindowViewports);
        return _this;
    }
    Object.defineProperty(Grid.prototype, "type", {
        get: function () {
            return ComponentTypes.grid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cellSize", {
        get: function () {
            return this._cellSize;
        },
        set: function (value) {
            this.setCellSize(value);
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.setCellSize = function (cellSize) {
        if (cellSize > 0) {
            this._cellSize = cellSize;
        }
    };
    Object.defineProperty(Grid.prototype, "cellMargin", {
        get: function () {
            return this._cellMargin;
        },
        set: function (value) {
            this.setCellMargin(value);
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.setCellMargin = function (cellMargin) {
        if (cellMargin >= 0) {
            this._cellMargin = cellMargin;
        }
    };
    Object.defineProperty(Grid.prototype, "rows", {
        get: function () {
            return this._rows;
        },
        set: function (value) {
            this.setRows(value);
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.setRows = function (rows) {
        if (rows > 0) {
            this._rows = rows;
        }
    };
    Object.defineProperty(Grid.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (value) {
            this.setColumns(value);
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.setColumns = function (columns) {
        if (columns > 0) {
            this._columns = columns;
        }
    };
    Object.defineProperty(Grid.prototype, "config", {
        get: function () {
            return {
                type: this.type,
                cellSize: this.cellSize,
                cellMargin: this.cellMargin,
                rows: this.rows,
                columns: this.columns,
                windows: this.windows.filter(function (w) { return !w.transient; }).map(function (w) { return w.config; }),
                closeDisabled: this.closeDisabled
            };
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.setConfig = function (config) {
        var _this = this;
        this.windows = [];
        var windowPromise;
        if (config && config.windows && config.windows.length > 0) {
            windowPromise = Promise.all(config.windows.map(function (wc) {
                var w = new Window_1.Window();
                _this.add(w);
                return w.setConfig(wc);
            }));
        }
        else {
            windowPromise = Promise.resolve();
        }
        return windowPromise.then(mobx_1.action(function () {
            _this.setCellSize(config ? config.cellSize : undefined);
            _this.setCellMargin(config ? config.cellMargin : undefined);
            _this.setRows(config ? config.rows : undefined);
            _this.setColumns(config ? config.columns : undefined);
            _this.setCloseDisabled(config ? config.closeDisabled : undefined);
        }));
    };
    Grid.prototype._getGridData = function (w) {
        var gridData = w.settings.data.grid;
        if (!gridData) {
            // TODO: make this configurable
            gridData = { colSpan: 6, rowSpan: 4 };
        }
        return gridData;
    };
    __decorate([
        mobx_1.observable
    ], Grid.prototype, "_cellSize", void 0);
    __decorate([
        mobx_1.observable
    ], Grid.prototype, "_cellMargin", void 0);
    __decorate([
        mobx_1.observable
    ], Grid.prototype, "_rows", void 0);
    __decorate([
        mobx_1.observable
    ], Grid.prototype, "_columns", void 0);
    __decorate([
        mobx_1.computed
    ], Grid.prototype, "cellSize", null);
    __decorate([
        mobx_1.action
    ], Grid.prototype, "setCellSize", null);
    __decorate([
        mobx_1.computed
    ], Grid.prototype, "cellMargin", null);
    __decorate([
        mobx_1.action
    ], Grid.prototype, "setCellMargin", null);
    __decorate([
        mobx_1.computed
    ], Grid.prototype, "rows", null);
    __decorate([
        mobx_1.action
    ], Grid.prototype, "setRows", null);
    __decorate([
        mobx_1.computed
    ], Grid.prototype, "columns", null);
    __decorate([
        mobx_1.action
    ], Grid.prototype, "setColumns", null);
    __decorate([
        mobx_1.computed
    ], Grid.prototype, "config", null);
    __decorate([
        mobx_1.action
    ], Grid.prototype, "setConfig", null);
    return Grid;
}(WindowManager_1.WindowManager));
exports.Grid = Grid;
